<template>
    <v-container class="container">
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-system-bar height="70px" dark color="secondary" dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Eleos Actions Form
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-system-bar>
                <v-tabs centered>
                    <v-tab>General Information</v-tab>
                    <v-tab-item class="mx-5">
                        <v-row justify="center">
                            <v-col cols="6">
                                <v-text-field
                                    label="Action Name"
                                    v-model="editedItem.Action"
                                    required
                                    :rules="[v => !!v || 'Action Name required']"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs>

                 <v-container>
                    <v-row justify="end" class="mb-2 mr-2">
                        <v-btn
                            dark
                            color="secondary"
                            class="mx-5 white--text"
                            @click="validate()"
                        >
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn
                            exact
                            dark
                            color="secondary"
                            class="mr-5 white--text"
                            :to="'/catalogs/eleos-actions'"
                        >
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                    </v-row>
                </v-container> 
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    // name: 'EliosActionsDorm',
    data() {
        return {
            ActionId: 0,
            defaultItem: {
                Action: null,
                Active: null
            },
            editedItem: {
                Action: null,
                Active: null
            },
            valid: true
        };
    },
    mounted() {
        if(this.$store.state.editedAction.ActionId > 0){
            this.loadEleosActions();    
        }
    },
    methods: {
        loadEleosActions: function() {
            this.$store.state.isLoading = true;
            this.ActionId = this.$store.state.editedAction.ActionId;
            var str = this.$store;
            if (this.ActionId != 0) {
                axios
                    .get('action/' + this.ActionId, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.editedItem = Object.assign({}, response.data);
                        this.$store.state.editedAction.id = 0;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        newEleosAction: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(this.editedItem);
            this.editedItem.Active = true;
            axios
                .post('action', this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New action added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/eleos-actions');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        editAction: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .put('action/' + this.ActionId, this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Action information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/eleos-actions');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        
        editEleosAction: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .put('action/' + this.edited.id, this.edited, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        save: function() {
            if (this.ActionId > 1) {
                this.editAction();
            } else {
                this.newEleosAction();
            }
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.save();
            }
        }
    }
};
</script>
